import React from 'react';
type PrimaryButtonProps = {
  children: React.ReactNode;
  onClick: () => void;
  variant?: 'solid' | 'outline';
  className?: string;
};
export function PrimaryButton({
  children,
  onClick,
  variant = 'solid',
  className = ''
}: PrimaryButtonProps) {
  const look = variant === 'solid' ? 'bg-ink text-white hover:bg-accent' : 'border border-ink/15 bg-white text-ink hover:border-ink';
  return <button type="button" onClick={onClick} className={`h-14 w-full rounded-full text-[13px] font-semibold tracking-[0.14em] transition-[background-color,border-color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${look} ${className}`} data-id="element-167" data-mp="2mnoj7nr4wz4e">
      {children}
    </button>;
}